export const TIME_ENTRY_REGEX = /^(([0-9]+h[0-9]+m)|([0-9]+h)|([0-9]+m))$/gi;
export const ROLE_TYPES = ['regular', 'non-regular', 'billed-only', 'inactive'];
export const default_role_type = 'billed-only';
